import ChangeBrowser from './ChangeBrowser';

export default ChangeBrowser;
